import Vue from 'vue'
import Component from 'vue-class-component'
import { getSnipcartInstance, Snipcart } from '@plugins/snipcart'
import { http } from '@ts/plugins/http'
import bus from '@shared/bus'

@Component
export default class MixinSnipcart extends Vue {
  private customer: any = null

  private reportSnipcartFailure(event: string) {
    const sentry = (window as any).Sentry

    if (!sentry || typeof sentry.captureMessage !== 'function') {
      return
    }

    const message = `Snipcart ${event}`

    if (typeof sentry.withScope !== 'function') {
      sentry.captureMessage(message, 'error')
      return
    }

    sentry.withScope((scope: any) => {
      scope.setTag('integration', 'snipcart')
      scope.setTag('snipcart.event', event)
      sentry.captureMessage(message, 'error')
    })
  }

  private get hasCustomer() {
    return this.customer !== null
  }

  private async customerRegister(customer: any) {
    await http.post('accounts', { email: customer.email })
    _state.isLoggedIn = true
    bus.$emit('login')
  }

  private async customerSignedin(customer: any) {
    await http.post('accounts', { email: customer.email })
    _state.isLoggedIn = true
    bus.$emit('login')
  }

  private async customerSignedout(customer: any) {
    await http.post('accounts/logout')
    _state.isLoggedIn = false
    bus.$emit('logout')
  }

  private bindListeners(snipcart: Snipcart) {
    snipcart.on('customer.registered', this.customerRegister)
    snipcart.on('customer.signedin', this.customerSignedin)
    snipcart.on('customer.signedout', this.customerSignedout)
    snipcart.on('payment.failed', () => this.reportSnipcartFailure('payment.failed'))
    snipcart.on('cart.confirm.error', () => this.reportSnipcartFailure('cart.confirm.error'))

    const unsubscribe = snipcart.store.subscribe(() => {
      const state = snipcart.store.getState()

      if (state.customer.email) {
        this.customer = state.customer
        unsubscribe()
      }
    })
  }

  private checkSession(snipcart: Snipcart) {
    // check if there is a Snipcart session despite isLoggedIn being false
    if (_state.isLoggedIn) {
      return
    }

    const customer = snipcart.store.getState().customer
    if (customer.email) {
      this.customerSignedin(customer)
    }
  }

  private mounted() {
    document.addEventListener('snipcart.initialization.error', () => {
      this.reportSnipcartFailure('initialization.error')
    })

    getSnipcartInstance()
      .then((instance) => {
        this.bindListeners(instance)
        this.checkSession(instance)
      })
  }
}
